import { DOCTYPES } from '@/constants/doctypes'
import { HAS_LIST_VIEW_ONE_PERMISSION_OF } from '@/constants/permissions'
import { createSingleViewRoutes } from '@/routers/routes/createDoctypeRoutes'

const { home: routeStockBalanceHome, root: routeStockBalanceRoot } = createSingleViewRoutes({
  doctypes: {
    [DOCTYPES.STOCK_ENTRY]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
  },
  ifOwner: false,
  name: 'stock-balance',
  path: 'balance',
  view: async () => await import('@/components/views/stock/StockBalance.vue'),
})

export { routeStockBalanceHome, routeStockBalanceRoot }
